import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function CampaignIntelligenceIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon width="24px" height="25px" viewBox="0 0 24 25" fill="none" {...props}>
      <rect width="21.231" height="21.231" x="1.385" y="2.049" stroke="currentColor" rx="1.542" />
      <Box
        as="path"
        stroke="currentColor"
        d="m1.385 19.852 7.15-7.15c.351-.351.829-.55 1.327-.55h5.824c.493 0 .967-.193 1.318-.54l5.653-5.573"
      />
      <mask
        id={`campaign-intelligence-a${id}`}
        width="22"
        height="18"
        x="1"
        y="6"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <Box
          as="path"
          fill="#A30044"
          d="m8.493 12.664-6.562 6.56a1.87 1.87 0 0 0-.546 1.321v.645c0 1.031.835 1.867 1.867 1.867h19.282V6.477a.184.184 0 0 0-.312-.13l-5.308 5.232c-.35.345-.82.538-1.311.538h-5.79c-.495 0-.97.196-1.32.547Z"
        />
      </mask>
      <g mask={`url(#campaign-intelligence-a${id})`}>
        <Box
          as="path"
          stroke="currentColor"
          d="m18.527 10.047 25.89 25.891M15.797 12.14l26.209 26.21M10.999 12.168l28.414 28.415M7.874 13.867l9.258 9.264M5.461 16.278l6.895 6.894"
        />
        <Box as="path" stroke="currentColor" d="m3.05 18.691 4.455 4.456" />
      </g>
    </Icon>
  );
}
